<template>
  <div>
    <common-table
        :table-columns="tableColumns"
        :url="url"
        :operate="operate"
        :searchs="searchs"
        :form-fields="formFields"
        :permission="permission"
        :buttons="buttons"
        ref="table"
        @returnId="returnId"
        pageName="QianchuanMultiProductScheduleTask"
    />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'QianchuanMultiProductScheduleTask',
  components: { CommonTable },
  data() {
    return {
      // 搜索配置（无修改，保持原有逻辑）
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'groupId',
        placeholder: '账户分组',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiserGroup/getAll',
        selectData: [],
      }, {
        name: 'advertiserId',
        placeholder: '广告主',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
      }, {
        name: 'ruleName',
        placeholder: '任务名称',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{key: 0, value: '关闭'}, {key: 1, value: '开启'}]
      }, {
        name: 'roiType',
        placeholder: 'ROI类型',
        type: 'select',
        selectValue: [{key: 1, value: '固定ROI'}, {key: 2, value: '按佣金率配置ROI'}]
      }, {
        name: 'repeatType',
        placeholder: '重复方式',
        type: 'select',
        selectValue: [{key: 1, value: '每天'}, {key: 2, value: '工作日'}, {key: 3, value: '每周'}, {
          key: 4,
          value: '仅一次'
        }]
      }, {
        name: 'taskStartSetTimeFrom',
        placeholder: '任务开始设定时间 - 筛选开始',
        type: 'dateTime'
      }, {
        name: 'taskStartSetTimeTo',
        placeholder: '任务开始设定时间 - 筛选结束',
        type: 'dateTime'
      }, {
        name: 'taskLatestExecuteTimeFrom',
        placeholder: '任务最近执行时间 - 筛选开始',
        type: 'dateTime'
      }, {
        name: 'taskLatestExecuteTimeTo',
        placeholder: '任务最近执行时间 - 筛选结束',
        type: 'dateTime'
      }, {
        name: 'taskEndSetTimeFrom',
        placeholder: '任务设定结束时间 - 筛选开始',
        type: 'dateTime'
      }, {
        name: 'taskEndSetTimeTo',
        placeholder: '任务设定结束时间 - 筛选结束',
        type: 'dateTime'
      }],

      // 权限配置（无修改）
      permission: {
        add: 'qianchuanScheduleTask:add',
        update: 'qianchuanScheduleTask:update',
        delete: 'qianchuanScheduleTask:delete',
        deleteBatch: 'qianchuanScheduleTask:deleteBatch'
      },

      // 接口配置（无修改，假设后端已支持productMax字段接收）
      url: {
        get: '/qianchuanScheduleTask/listByCondition',
        add: '/qianchuanScheduleTask/add',
        update: '/qianchuanScheduleTask/update',
        delete: '/qianchuanScheduleTask/delete',
        delete_batch: '/qianchuanScheduleTask/deleteBatch',
        status: '/qianchuanScheduleTask/status',
      },

      // 表格列配置：新增【最大商品数】列（关键修改1）
      tableColumns: [
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {type: 'select'},
        }, {
          field: 'advertiserName',
          label: '广告主',
          sort: false,
          show: true,
        }, {
          field: 'ruleName',
          label: '任务名称',
          sort: false,
          show: true,
        }, {
          field: 'planNameRule',
          label: '计划名称规则',
          sort: false,
          show: false,
        }, {
          field: 'dailyBudget',
          label: '日预算',
          sort: false,
          show: true,
        },  {
          field: 'startTime',
          label: '开始时间',
          sort: false,
          show: true,
        }, {
          field: 'repeatType',
          label: '重复方式',
          sort: false,
          show: {
            type: 'tag',
            tags: [
              {key: 1, value: '每天', type: 'success'},
              {key: 2, value: '工作日', type: 'info'},
              {key: 3, value: '每周', type: 'warning'},
              {key: 4, value: '一次', type: 'danger'}
            ]
          },
        }, {
          field: 'status',
          label: '状态',
          sort: false,
          status: true,
          show: {
            type: 'tag',
            tags: [
              {key: 0, value: '停用', type: 'danger'},
              {key: 1, value: '开启', type: 'success'}
            ]
          },
        }, {
          field: 'lastExecuteTime',
          label: '最近执行时间',
          sort: false,
          show: true,
        }, {
          field: 'endTime',
          label: '结束时间',
          sort: false,
          show: true,
        }, {
          field: 'createTime',
          label: '创建时间',
          show: true,
          width: '',
        },
      ],

      // 表单配置：新增【最大商品数】字段（关键修改2）
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        labelWidth: '100px',
        addGuide: {
          title: '多品智能定时投放任务说明',
          summary: '这张表单用于给多个商品批量建立自动投放规则。保存后，系统会按你设定的时间、账户和执行频率，自动为可投放商品创建计划。',
          icon: 'el-icon-time',
          points: [
            '适合同一账户下需要批量、定时创建多商品计划的场景。',
            '开始时间需晚于当前时间至少 10 分钟，避免保存后立即误触发。',
            '日预算、执行频率可按业务节奏配置；结束时间留空表示长期执行。'
          ]
        },
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'ruleName',
          label: '任务名称',
          type: 'input',
          placeholder: '请输入任务名称',
          rules: [{required: true, message: '任务名称不能为空', trigger: 'blur'}],
          add: true,
          update: true,
        }, {
          field: 'accountIds',
          label: '账户：',
          type: 'select',
          placeholder: '请选择账户',
          tip: '提示：可多选账户；支持全选/取消全选。仅展示当前可投放账户。',
          rules: [{required: true, message: '请选择账户', trigger: 'blur'}],
          selectUrl: '/qianchuanScheduleTask/getAbleInvestAccount',
          multiple: true,
          isSelectAll: true,
          selectData: [],
          add: true,
          update: false,
          isGet: true,
          filterable: true,
        }, {
          field: 'dailyBudget',
          label: '日预算',
          type: 'input',
          placeholder: '请输入日预算',
          rules: [{required: true, message: '日预算不能为空', trigger: 'blur'}],
          add: true,
          update: true,
        }, {
          field: 'startTime',
          label: '开始时间',
          type: 'dateTime',
          placeholder: '请选择开始时间',
          tip: '提示：开始时间应大于当前时间 10 分钟以上。',
          rules: [
            {required: true, message: '开始时间不能为空', trigger: 'blur'},
            {
              validator: (rule, value, callback) => {
                if (!value) return callback();
                const tenMinutesLater = new Date(Date.now() + 10 * 60 * 1000);
                if (new Date(value) < tenMinutesLater) {
                  callback(new Error('开始时间应大于当前时间10分钟'));
                } else callback();
              },
              trigger: ['blur', 'change']
            }
          ],
          add: true,
          update: true,
        }, {
          field: 'repeatType',
          label: '执行频率',
          type: 'select',
          placeholder: '执行频率',
          rules: [{required: true, message: '执行频率不能为空', trigger: 'blur'}],
          selectData: [{id: 1, name: '每天'}, {id: 2, name: '工作日'}, {id: 3, name: '每周'}, {id: 4, name: '一次'}],
          add: true,
          update: true,
        }, {
          field: 'endTime',
          label: '结束时间',
          type: 'dateTime',
          placeholder: '请选择结束时间',
          rules: [{required: false, message: '结束时间不能为空', trigger: 'blur'}],
          add: true,
          update: true,
        },]
      },

      // 操作列配置（无修改）
      operate: [{
        icon: 'el-icon-tickets',
        type: 'text',
        text: '日志',
        handle: (row) => {
          this.$router.push({
            path: '/qdd/admin/QianchuanTaskLog.html',
            query: {id: row.advertiserId, getLog: true}
          })
        }
      }],

      // 按钮配置（无修改）
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量修改任务状态',
        notNeedPermission: true,
        click: () => {
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要修改视频状态的任务');
            return;
          }
          request.post({
            url: '/qianchuanScheduleTask/batch/status',
            data: {ids: this.selectIds.join(",")},
            success: (data) => {
              if (data.code === 0) {
                message.success("批量修改视频状态成功");
                this.$refs.table.getData();
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      }],

      // 选中的ID（无修改）
      selectIds: []
    }
  },
  methods: {
    returnId(data) {
      this.selectIds = data;
      console.log('选中的ID:', this.selectIds);
    }
  }
}
</script>

<style scoped></style>
